import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { LIST_PAGE_COUNT } from '../../data/common';
import TablePaginationActions from '../TablePaginationActions';
import { map } from 'lodash';
import BonusProductQRCodeGroupTableRow from './BonusProductQRCodeGroupTableRow';

const BonusProductQRCodeGroupTable = (props) => {
  const {
    QRCodeGroups,
    total,
    page,
    setPage,
    isLoading,
    downloadQRCode,
    openDetail,
  } = props;

  return (
    <TableContainer component={Box}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>QRCode</TableCell>
            <TableCell>打包數量</TableCell>
            <TableCell>建立時間</TableCell>
            <TableCell align="right">功能</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {QRCodeGroups &&
            map(QRCodeGroups, (QRCodeGroup) => {
              return (
                <BonusProductQRCodeGroupTableRow
                  key={QRCodeGroup.groupId}
                  QRCodeGroup={QRCodeGroup}
                  isLoading={isLoading}
                  downloadQRCode={downloadQRCode}
                  openDetail={openDetail}
                />
              );
            })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[LIST_PAGE_COUNT]}
              colSpan={5}
              count={total}
              rowsPerPage={LIST_PAGE_COUNT}
              page={page - 1}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={(event, currentPage) => {
                setPage(currentPage + 1);
              }}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default BonusProductQRCodeGroupTable;
